import React from 'react';
import './assets/css/Loader.css';

const ALLOWED_POSITIONS = ['center-center', 'top-center', 'top-left'];

export default ({ position = 'center-center' }) => {
    if (ALLOWED_POSITIONS.indexOf(position) !== -1) {
        position = 'center-center';
    }

    return <div className={`Loader loader--${position}`} />;
};
